import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LoggingService } from 'app/wipperoz-core/services/logging.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BlogService } from './blog.service';
import { BlogContent } from './types/blog-content.model';
import { Tags } from './types/tags.model';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BlogComponent implements OnInit, OnDestroy {
  blogImageAlt = $localize`:@@blogImageAlt:Blog image`;
  blogImage =
    'https://cdn.sanity.io/images/jizm7zxy/production/1a237ab87d39c29cda3b3aa12b94c34325a05607-1920x1054.png?fm=webp&q=75';

  latestContent: BlogContent[] = [];
  tags: Tags[] = [];

  private unsubscribeAll: Subject<any>;

  constructor(private router: Router, private blogService: BlogService, private loggingService: LoggingService) {
    this.unsubscribeAll = new Subject();
  }

  get blogTitle(): string {
    return this.blogService.blogTitle;
  }

  get blogSubtitle(): string {
    return this.blogService.blogSubtitle;
  }

  get search(): string {
    return this.blogService.options.searchCriteria;
  }

  set search(value: string) {
    this.blogService.options.searchCriteria = value;
  }
  ngOnInit(): void {
    this.blogService.onResultsChanged.pipe(takeUntil(this.unsubscribeAll)).subscribe(
      (data) => {
        if (data !== null) {
          this.blogService.totalCount = this.blogService.totalCount;
          this.latestContent = this.blogService.latestContent;
          this.tags = this.blogService.tags;
        }
      },
      (err) => {
        this.loggingService.logError('Error getting blog content', JSON.stringify(err));
      }
    );

    this.blogService.getBlogContent(this.blogService.options);
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }

  onSubmitSearch(): void {
    this.blogService.getBlogContent(this.blogService.options).then(() => {
      this.router.navigate(['/blog']);
    });
  }

  searchByTag(tag: string): void {
    this.blogService.options.page = 1;
    this.blogService.getBlogContentByTag(this.blogService.options, tag).then(() => {
      this.router.navigate(['/blog']);
    });
  }
}
